<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="12">
    
              <el-form :inline="true" :model="formInline" size="mini">
                <el-form-item>
                  <el-button type="default" icon="el-icon-s-fold" @click="collapseHTree"></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-edit" @click="openUserForm(0)">新增</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="default" icon="el-icon-download">导出</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form :inline="true" class="demo-form-inline" size="mini" style="text-align: right;">
                <el-form-item label="账号">
                  <el-input v-model="formInline.key" placeholder="请输入账号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="formInline.include_children">包含下级数据</el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchUserList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          
          <div class="sanmuui-body-container">
            <div class="sanmuui-body-left" v-show="displayHTreeVisible">
              <div class="tree-divBox">
                    <el-tree 
                        :data="holdTreeData" 
                        :props="defaultProps" 
                        default-expand-all 
                        ref="getTreeInstance" 
                    @node-click="handleNodeClick"></el-tree>
                </div>
            </div>
            <div class="sanmuui-body-right">
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                size="small"
                border
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="login_name"
                  label="账号"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="hold_name"
                  label="所属用户"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="true_name"
                  label="姓名"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="email"
                  label="邮箱"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="service_end"
                  label="到期日期"
                  :formatter="formatterDate"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="备注">
                </el-table-column>
                <el-table-column
                  prop="create_time"
                  label="录入时间"
                  :formatter="formatterTime"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="operator"
                  label="操作"
                  width="300">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="openStaffInfoForm(scope.row.user_id)">编辑</el-button>
                    <el-button
                      size="mini"
                      @click="ChangeUserPassword(scope.row.user_id, scope.row.login_name)">重置密码</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="removeUserInfo(scope.row.user_id)"
                      v-if="scope.row.hold_id!=1">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>
      </el-col>
    </el-row>

    <!-- 新增账号 -->
    <el-dialog title="新增账号" :visible.sync="dialogFormVisible" width="460px">
      <el-form :model="formNew" ref="formNew" :rules="rules" label-width="80px" class="demo-form-inline" size="medium">
        <el-form-item label="所属用户" prop="hold_name">
          <el-input v-model="formNew.hold_name" autocomplete="off" :disabled="true" class="-form2-input-text"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="login_name">
          <el-input v-model="formNew.login_name" autocomplete="off" class="-form2-input-text"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="displayPassword">
          <el-input v-model="formNew.password" autocomplete="off" class="-form2-input-text"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="true_name">
          <el-input v-model="formNew.true_name" autocomplete="off" class="-form2-input-text"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="formNew.email" autocomplete="off" class="-form2-input-text"></el-input>
        </el-form-item>
        <el-form-item label="服务到期" prop="service_end">
            <el-date-picker
              v-model="formNew.service_end"
              type="date"
              placeholder="选择日期" style="width: 300px;">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="formNew.remark" class="-form2-input-text"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="AddUserInfo('formNew')" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 重置账号密码 begin -->
     <el-dialog title="重置账号密码" :visible.sync="dailRepwdVisible" width="500px" :center="true">
        <el-form :model="fmpwd" label-width="100px" class="demo-form-inline" size="medium">
          <el-form-item label="新密码">
            <el-input v-model="fmpwd.password" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input v-model="fmpwd.repassword" autocomplete="off" class="-form2-input-text"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dailRepwdVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="SubmitChangePwd()" size="small">确 定</el-button>
        </div>
     </el-dialog>
    <!-- 重置账号密码 end -->

  </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'staffinfo_manage',
  data() {
    return {
      isVisible: false, // 控制浮动层是否显示
      dialogFormVisible: false,
      dailRepwdVisible: false,
      displayPassword: false,
      currentTabsNodeName: "staff-department",
      displayHTreeVisible: true,
      formInline: {
        hold_id: null,
        key: '',
        include_children: true,
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      tableViewHeight: 600,
      loadingTableData: false,
      selectHoldId: 0,
      selectedHoldName: "",
      holdTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      formNew: {
        user_id: 0,
        hold_id: null,
        hold_name: "",
        login_name: "",
        password: "",
        true_name: "",
        email: "",
        service_end: null,
        remark: ""
      },
      rules: {
        login_name: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        service_end: [
          { required: true, message: '请选择服务到期', trigger: 'blur' }
        ]
      },
      selectUserId: 0,
      selectUserName: '',
      fmpwd: {
        password: '',
        repassword: '',
      }
    }
  },
  methods: {
    openLayer() {
      this.isVisible = true;
    },
    closeLayer() {
      this.isVisible = false;
    },
    handleCurrentChange(val) {
      this.pagging.current_page = val;
      this.searchUserList();
    },
    formatterTime(row, column) {
      return row.create_time ? row.create_time.replace('T', ' ').substring(0, 19) : "";
    },
    formatterDate(row, column) {
      return row.create_time ? row.create_time.replace('T', ' ').substring(0, 10) : "";
    },
    collapseHTree: function() {
      if(this.displayHTreeVisible) {
        this.displayHTreeVisible = false;
      } else {
        this.displayHTreeVisible = true;
      }
    },
    loadHoldTree: function(){
      Api.GetHoldTree({}).then(res => {
        if(!res)
          return;
        this.holdTreeData = res.data;

        // 初始化选中的用户id
        this.selectHoldId = this.holdTreeData[0].id;
        this.selectedHoldName = this.holdTreeData[0].label;
      });
    },
    refreshPageList: function() {
      this.loadHoldTree();
      this.loadStaffInfoList();
    },
    searchUserList: function() {
      this.loadingTableData = true;
      this.formInline.hold_id = this.selectHoldId;

      this.formInline.page_index = this.pagging.current_page;
      this.formInline.page_size = this.pagging.pager_size;
      Api.UserList(this.formInline).then(res => {
        this.loadingTableData = false;
        if(res && res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          this.tableData = res.data;
        } else {
          // 暂无数据
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    handleNodeClick: function(data) {
      this.selectHoldId = data.id;
      this.selectedHoldName = data.label;
      this.searchUserList();
    },
    resetFormUserInfo: function() {
      this.formNew = {
        user_id: 0,
        hold_id: null,
        hold_name: "",
        login_name: "",
        password: "",
        true_name: "",
        email: "",
        service_end: null,
        remark: ""
      };
    },
    openUserForm: function(id) {
      this.formNew.user_id = id;
      this.dialogFormVisible = true;
      if(id > 0) {
        this.displayPassword = false;
        Api.UserDetail({ user_id: id }).then(res => {
          if(res && res.code === 200 && res.data) {
            this.formNew.hold_id = res.data.hold_id;
            this.formNew.hold_name = res.data.hold_name;
            this.formNew.login_name = res.data.login_name;
            this.formNew.true_name = res.data.true_name;
            this.formNew.email = res.data.email;
            this.formNew.service_end = res.data.service_end;
            this.formNew.remark = res.data.remark;
          } else {
            // 暂无数据
          }
        }).catch(err => {
          this.$message.error('错了哦，接口出错！' + err);
          this.loadingTableData = false;
        });
      } else {
        this.displayPassword = true;
        this.formNew.hold_id = this.selectHoldId;
        this.formNew.hold_name = this.selectedHoldName;
      }
    },
    AddUserInfo: function(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Api.AddUser(this.formNew).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '恭喜你，提交成功！',
                type: 'success'
              });
              this.resetFormUserInfo();
              this.dialogFormVisible = false;
              this.loadHoldTree();
              this.searchUserList();
            } else {
              this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    removeUserInfo: function(id) {
      this.$confirm('此操作将删除该账号信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
         var argdata = {
            user_ids: [
              id
            ]
          };
          Api.RemoveUser(argdata).then(res => {
            if(!res)
              return;

            if(res.code === 200) {
                this.$message({
                    message: '已删除！',
                    type: 'success'
                });
                this.loadHoldTree();
                this.searchUserList();
            } else {
                this.$message({
                    message: '删除失败！' + res.msg,
                    type: 'warning'
                });
            }
          });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    // 重置账号密码
    ChangeUserPassword: function(user_id, user_name) {
      this.selectUserId = user_id;
      this.selectUserName = user_name;
      this.dailRepwdVisible = true;
    },
    SubmitChangePwd: function() {
      if(!this.fmpwd.password ||
          !this.fmpwd.repassword) {
            this.$message.error('请输入密码及确认密码!');
            return;
          }
      if(this.fmpwd.password !== this.fmpwd.repassword) {
        this.$message.error('两次输入的密码不一致!');
        return;
      }
      if(this.fmpwd.password.length < 6) {
        this.$message.error('密码长度最少为6个以上字符!');
        return;
      }
      if(!this.selectUserId) {
        this.$message.error('操作异常，请刷新页面重新操作!');
        return;
      }

      var argdata = {
        user_id: this.selectUserId,
        new_password: this.fmpwd.password,
        user_name: this.selectUserName
      };
      Api.ChangeUserPassword(argdata).then(res => {
        if(!res)
          return;

        if(res.code === 200) {
            this.$message({
                message: '密码已重置！',
                type: 'success'
            });
            this.selectUserId = 0;
            this.selectUserName = '';
            this.dailRepwdVisible = false;

            this.loadHoldTree();
            this.loadHoldList();
        } else {
            this.$message({
                message: '重置失败！' + res.msg,
                type: 'warning'
            });
        }
      });
    }
  },
  mounted() {
    var h = document.body.clientHeight - 115;
    var h2 = document.body.clientHeight - 115;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.loadHoldTree();
    this.searchUserList();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
</style>